export const setUsers = users => {
  return {
    type: 'SET_USERS',
    payload: users,
  }
}
